module.exports = __webpack_public_path__ + "img/vip-1.c385be70.png";